const TambaLogo = ({ className = "h-8 w-8", showTagline = false }) => {
  return (
    <div 
      className={`bg-white rounded-lg p-1 inline-flex items-center justify-center ${className}`}
      style={{ aspectRatio: 'auto' }}
    >
      <img 
        src="https://customer-assets.emergentagent.com/job_easypay-global/artifacts/4el115r9_image.png" 
        alt="Tamba Logo"
        className="h-full w-full"
        style={{ objectFit: 'contain' }}
      />
    </div>
  );
};

export default TambaLogo;
